import React from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {ButtonSize} from 'ui-library/buttons/Button';
import UIPlaceholder from 'ui-library/UIPlaceholder';

import AddDataButton from '../AddDataButton';
import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EmptyAnalysisView({
  analysis,
  onOpenStepInitializationView,
}: MainViewComponentProps<AnalysisMainViewItemType.EMPTY_ANALYSIS>): JSX.Element {
  const {analysisToolEnableHeaderRedesign} = useRolloutFlags();
  return (
    <UIPlaceholder
      infoSection={
        !analysis.permissions.writable
          ? "This analysis doesn't have anything in it."
          : analysisToolEnableHeaderRedesign
            ? 'Add data to your analysis to get started.'
            : 'Get started by adding a table to this analysis.'
      }
      actionContent={
        !analysisToolEnableHeaderRedesign &&
        (analysis.permissions.writable || analysis.permissions.unarchivable) ? (
          <AddDataButton
            actionOrigin={ActionOrigin.ANALYSIS_TOOL_EMPTY_ANALYSIS_PAGE}
            analysis={analysis}
            buttonSize={ButtonSize.MEDIUM}
            onOpenStepInitializationView={onOpenStepInitializationView}
          />
        ) : undefined
      }
    />
  );
}
